import { useSnackbarContext } from '@/context/Snackbar/SnackbarContext';
import { passwordResetRequest } from '@/data/api/request/sellerPasswordResetRequest';
import { useMutation } from '@tanstack/react-query';

export function useSellerPasswordReset() {
  const { showSnackSuccess, showSnackError } = useSnackbarContext();

  const { isPending, mutate } = useMutation({
    mutationFn: async ({ email }: { email: string }) =>
      await passwordResetRequest(email),
    onSuccess: () =>
      showSnackSuccess('Se ha enviado el correo de recuperación.'),
    onError: () =>
      showSnackError('Hubo un problema al intentar enviar el correo.'),
  });

  return { resetPassword: mutate, isSending: isPending };
}
